export const offerContractSections = [
  {
    heading: 'ДОГОВОР-ОФЕРТА',
    paragraphs: [
      'на оказание услуг по продвижению сообществ, сайтов и каналов в социальных сетях и рекламных сетях',
    ],
  },
  {
    heading: '1. Общие положения',
    paragraphs: [
      '1.1. Настоящий документ является публичной офертой (предложением) Индивидуального предпринимателя, ИНН 165916429782, ОГРНИП 318169000008600 (далее — «Исполнитель»), заключить договор на оказание услуг по продвижению сообществ, сайтов и каналов в социальных сетях и рекламных сетях (далее — «Услуги») на условиях, изложенных ниже.',
      '1.2. Полным и безоговорочным акцептом настоящей оферты является оплата Заказчиком выбранного тарифа Услуг. С момента поступления оплаты договор считается заключённым, а условия настоящей оферты — согласованными сторонами.',
      '1.3. Акцептуя оферту, Заказчик подтверждает, что ознакомился и согласен со всеми условиями настоящего договора.',
    ],
  },
  {
    heading: '2. Предмет договора',
    paragraphs: [
      '2.1. Исполнитель обязуется оказать Заказчику услуги по продвижению сообщества, сайта или канала: таргетированная реклама, настройка и ведение рекламных кампаний, контент-стратегия, работа с охватами и вовлечением, аналитика и отчётность.',
      '2.2. Конкретный перечень услуг, объём работ и целевые показатели (KPI) определяются выбранным тарифом и согласовываются сторонами до начала работ.',
      '2.3. Запуск и ведение рекламных кампаний осуществляется через рекламный кабинет Исполнителя.',
    ],
  },
  {
    heading: '3. Стоимость и порядок оплаты',
    paragraphs: [
      '3.1. Стоимость Услуг определяется выбранным тарифом и фиксируется в момент акцепта оферты.',
      '3.2. Рекламный бюджет включён в стоимость выбранного тарифа и пополняется Исполнителем за свой счёт. Рекламные кампании запускаются и ведутся через рекламный кабинет Исполнителя.',
      '3.3. Оплата услуг Исполнителя производится на условиях выбранного тарифа в порядке предоплаты либо по согласованному сторонами графику.',
    ],
  },
  {
    heading: '4. Права и обязанности сторон',
    paragraphs: [
      '4.1. Исполнитель обязуется оказывать Услуги качественно, предоставлять еженедельную отчётность и соблюдать согласованные сроки.',
      '4.2. Заказчик обязуется предоставить Исполнителю доступ администратора к сообществу, сайту или каналу для выполнения работ по настоящему договору.',
      '4.3. Заказчик обязуется предоставлять необходимые для работы материалы и доступы и своевременно оплачивать Услуги.',
      '4.4. Запуск и ведение рекламных кампаний осуществляется с соблюдением требований Федерального закона от 13.03.2006 № 38-ФЗ «О рекламе» и иных нормативных правовых актов Российской Федерации, регулирующих рекламную деятельность.',
      '4.5. Для запуска рекламы обязательно соответствие законодательству «О рекламе». По запросу рекламной платформы Заказчик обязуется пройти процедуру модерации и/или аккредитации, включая предоставление документов и сведений, подтверждающих соответствие рекламируемых товаров, работ и услуг установленным требованиям, в объёме и порядке, запрошенных платформой.',
      '4.6. В случае непрохождения модерации и/или аккредитации запуск рекламы может быть отложен до устранения замечаний либо приостановлен. Исполнитель не несёт ответственности за ограничения и отказы, наложенные рекламной платформой в соответствии с её правилами и требованиями законодательства.',
    ],
  },
  {
    heading: '5. Отчётность',
    paragraphs: [
      '5.1. Исполнитель предоставляет Заказчику еженедельный отчёт по охватам, подпискам и заявкам, а также ежемесячный сводный отчёт.',
      '5.2. Все целевые показатели (подписчики, охват, стоимость заявки) фиксируются в договоре и контролируются сторонами.',
    ],
  },
  {
    heading: '6. Ответственность сторон',
    paragraphs: [
      '6.1. Стороны несут ответственность за неисполнение или ненадлежащее исполнение обязательств в соответствии с действующим законодательством Российской Федерации.',
      '6.2. Если по итогам 30 (тридцати) календарных дней непрерывной работы Исполнитель не выполнил условия выбранного тарифа и не достиг результата, указанного в тарифе, Заказчик вправе по своему выбору потребовать: возврат полной стоимости тарифа либо продолжение продвижения за счёт Исполнителя до достижения заявленного результата.',
      '6.3. Возврат полной стоимости тарифа возможен только при условии, что Исполнитель отработал 30 (тридцать) календарных дней и при этом не достиг результата, указанного в тарифе. В случае достижения результата либо при невыполнении Заказчиком своих обязательств по настоящему договору возврат не производится.',
    ],
  },
  {
    heading: '7. Срок действия и порядок расторжения',
    paragraphs: [
      '7.1. Договор вступает в силу с момента акцепта оферты и действует до полного исполнения сторонами обязательств.',
      '7.2. Договор может быть расторгнут в любой момент по договорённости сторон. Неизрасходованный рекламный бюджет возвращается Заказчику, а уже выполненные работы оплачиваются по факту без штрафов.',
    ],
  },
  {
    heading: '8. Реквизиты Исполнителя',
    paragraphs: [
      'Индивидуальный предприниматель',
      'ИНН 165916429782',
      'ОГРНИП 318169000008600',
    ],
  },
];